import { z } from 'zod';

import { documentDataSchema } from '@/features/ui/DocumentsData/model/schemas';

import { zodSelectOption } from '@/shared/lib/validations';
import { addressBlockSchema } from '@/shared/ui/AddressBlock/model';

import { YesNoSelectOptions } from '@/components/Forms/constants';

const optionalAddressSchema = addressBlockSchema.optional();
const optionalDocumentsSchema = z.any().optional();

export const placeOfResidenceBaseSchema = z.object({
  registeredAddress: addressBlockSchema,
  declaredDocRent: documentDataSchema,
  isAddressesEqual: zodSelectOption,
  actualAddress: optionalAddressSchema,
  actualPlaceOfResidence: optionalDocumentsSchema,
});

export const placeOfResidenceSchema = placeOfResidenceBaseSchema.superRefine((data, ctx) => {
  const isDifferentAddress = data.isAddressesEqual?.id === YesNoSelectOptions.NO.id;

  if (isDifferentAddress) {
    const addressValidation = addressBlockSchema.safeParse(data.actualAddress);
    if (!addressValidation.success) {
      addressValidation.error.issues.forEach((issue) => {
        ctx.addIssue({
          ...issue,
          path: ['actualAddress', ...issue.path],
        });
      });
    }

    const documentsValidation = documentDataSchema.safeParse(data.actualPlaceOfResidence);
    if (!documentsValidation.success) {
      documentsValidation.error.issues.forEach((issue) => {
        ctx.addIssue({
          ...issue,
          path: ['actualPlaceOfResidence', ...issue.path],
        });
      });
    }
  }
});
